export default function StatsSection() {
  const stats = [
    { icon: 'ri-user-line', value: '5000万+', label: '全球用户' },
    { icon: 'ri-star-line', value: '4.8', label: '用户评分' },
    { icon: 'ri-shield-check-line', value: '99.9%', label: '安全拦截率' },
    { icon: 'ri-speed-up-line', value: '40%', label: '速度提升' },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-14 h-14 mx-auto mb-3 rounded-2xl bg-accent-100 flex items-center justify-center">
                <i className={`${stat.icon} text-2xl text-accent-600`}></i>
              </div>
              <p className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-1">
                {stat.value}
              </p>
              <p className="text-sm text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}